import React from 'react';
import { useSelector } from 'react-redux';

const ColorLegend = ({ isHomePage }) => {
    const colorCodes = useSelector((state) => state.plannedItemState.colorCodes);

    // isHomePage === true then remove the colorcode that has systemName === recycle from the list
    const filteredColorCodes = isHomePage ? colorCodes.filter(cc => cc.systemName !== 'recycle') : colorCodes;

    const components = filteredColorCodes.map((cc) => {
        const style = {color: cc.hexColor}
        return (<li className='legend' key={cc.name} style={style}><p>{cc.name}</p></li>)
    });

    return (
        <ul className="legend-container">
            {components}
        </ul>
    );
};

export default ColorLegend;